import { ContactsState, Registrant } from 'src/types/flow';
import {
  APIPerson,
  FormModelPerson,
  MiscPerson,
  Person,
} from 'src/types/person';

const validPeopleKeys = [
  'registrant',
  'owner',
  'localContact',
  'propertyManager',
  'tenant',
];

export const sanitizePeople = (
  people: ContactsState | Registrant | undefined
): Record<string, Person | Person[]> => {
  if (!people) return {};
  return Object.entries(people).reduce(
    (acc: Record<string, Person | Person[]>, [key, person]) => {
      if (validPeopleKeys.includes(key)) {
        if (Array.isArray(person)) {
          acc[key] = person.map((potentialPerson) =>
            sanitizePersonObject(potentialPerson)
          );
        } else {
          acc[key] = sanitizePersonObject(person);
        }
      }
      return acc;
    },
    {}
  );
};

export const sanitizePersonObject = (person: FormModelPerson): APIPerson => {
  let misc: MiscPerson | undefined;
  if (person?.completePhysicalAddress?.value) {
    misc = {
      physicalAddress: person.completePhysicalAddress.value,
      physicalAddressComponents: person.completePhysicalAddress.components,
    };
  }
  return {
    firstName: person?.firstName ?? '',
    lastName: person?.lastName ?? '',
    email: person?.email ?? '',
    phone: person?.phone ?? '',
    mailingAddress: person?.mailingAddress ?? '',
    companyName: person?.companyName ?? '',
    misc,
  };
};
